import { IEntitiesConfig } from '../types/types';
export const entitiesConfig: IEntitiesConfig = {
  // ---------------------------------------------------------------------------
  // Player
  // ---------------------------------------------------------------------------
  player: {
    width: 20,
    height: 20,
    anchor: [0.5, 0.8],
    animations: {
      run: { spriteTextureName: 'lumephons-run' },
      getUp: { spriteTextureName: 'lumephons-getUp' },
      idle: { spriteTextureName: 'lumephons-idle' },
      casting: { spriteTextureName: 'lumephons-idleHoldingToolSword' },
      attack: { spriteTextureName: 'lumephons-swordAttackSword' },
      exhaust: { spriteTextureName: 'lumephons-idleHoldingToolSword' },
      die: { spriteTextureName: 'lumephons-die' },
      'attack-axe': { spriteTextureName: 'lumephons-swingAxe' },
      'casting-axe': { spriteTextureName: 'lumephons-idleHoldingToolAxe' },
    },
  },
  // ---------------------------------------------------------------------------
  // Monsters
  // ---------------------------------------------------------------------------
  spider: {
    width: 40,
    height: 40,
    anchor: [0.5, 0.5],
    animations: {
      run: { spriteTextureName: 'spider-run' },
      idle: { spriteTextureName: 'spider-idle' },
      casting: { spriteTextureName: 'spider-dizzy' },
      attack: { spriteTextureName: 'spider-attack' },
      exhaust: { spriteTextureName: 'spider-dizzy' },
      die: { spriteTextureName: 'spider-die' },
    },
  },
  demon: {
    width: 40,
    height: 40,
    anchor: [0.5, 0.5],
    animations: {
      run: { spriteTextureName: 'demon-run' },
      idle: { spriteTextureName: 'demon-idle' },
      casting: { spriteTextureName: 'demon-roar' },
      attack: { spriteTextureName: 'demon-attackPunch' },
      swipe: { spriteTextureName: 'demon-attackSwipe' },
      exhaust: { spriteTextureName: 'demon-idle' },
      die: { spriteTextureName: 'demon-death' },
    },
  },
  hydra: {
    width: 40,
    height: 40,
    anchor: [0.5, 0.5],
    animations: {
      run: { spriteTextureName: 'hydra-walk' },
      idle: { spriteTextureName: 'hydra-idle' },
      casting: { spriteTextureName: 'hydra-idle' },
      attack: { spriteTextureName: 'hydra-attack' },
      fireBreath: { spriteTextureName: 'hydra-fireBreath' },
      exhaust: { spriteTextureName: 'hydra-hit' },
      die: { spriteTextureName: 'hydra-death' },
    },
  },
  kitsune: {
    width: 64,
    height: 64,
    anchor: [0.5, 0.5],
    animations: {
      run: { spriteTextureName: 'kitsune-run' },
      idle: { spriteTextureName: 'kitsune-idle' },
      casting: { spriteTextureName: 'kitsune-idle' },
      attack: { spriteTextureName: 'kitsune-attack' },
      exhaust: { spriteTextureName: 'kitsune-hit' },
      die: { spriteTextureName: 'kitsune-death' },
      disappear: { spriteTextureName: 'kitsune-disappear' },
      appear: { spriteTextureName: 'kitsune-appear' },
    },
  },
  watcher: {
    width: 40,
    height: 40,
    anchor: [0.5, 0.5],
    animations: {
      run: { spriteTextureName: 'watcher-walk' },
      idle: { spriteTextureName: 'watcher-idle' },
      // No dedicated "casting" sprite — reuse idle (the watcher channels
      // without changing pose before `attack` plays).
      casting: { spriteTextureName: 'watcher-idle' },
      attack: { spriteTextureName: 'watcher-attack' },
      exhaust: { spriteTextureName: 'watcher-idle' },
      die: { spriteTextureName: 'watcher-death' },
    },
  },
  whisper: {
    width: 40,
    height: 40,
    anchor: [0.5, 0.65],
    animations: {
      // No dedicated "run" / "casting" in the spritesheet — fall back to idle
      // (the whisper moves slowly, with no distinct animation).
      run: { spriteTextureName: 'whisper-idle' },
      idle: { spriteTextureName: 'whisper-idle' },
      casting: { spriteTextureName: 'whisper-idle' },
      attack: { spriteTextureName: 'whisper-attack' },
      exhaust: { spriteTextureName: 'whisper-idle' },
      die: { spriteTextureName: 'whisper-death' },
    },
  },
  parasite: {
    width: 64,
    height: 64,
    anchor: [0.5, 0.55],
    animations: {
      run: { spriteTextureName: 'parasite-walk' },
      idle: { spriteTextureName: 'parasite-idle' },
      casting: { spriteTextureName: 'parasite-awake' },
      attack: { spriteTextureName: 'parasite-attack1' },
      attack2: { spriteTextureName: 'parasite-attack2' },
      exhaust: { spriteTextureName: 'parasite-hit' },
      die: { spriteTextureName: 'parasite-death' },
      awake: { spriteTextureName: 'parasite-awake' },
      startWalk: { spriteTextureName: 'parasite-startWalk' },
    },
  },
  fiend: {
    width: 50,
    height: 50,
    anchor: [0.57, 0.57],
    animations: {
      run: { spriteTextureName: 'fiend-run' },
      idle: { spriteTextureName: 'fiend-idle' },
      casting: { spriteTextureName: 'fiend-idle' },
      attack: { spriteTextureName: 'fiend-attack' },
      exhaust: { spriteTextureName: 'fiend-exhaust' },
      die: { spriteTextureName: 'fiend-die' },
    },
  },
  dragon: {
    width: 80,
    height: 80,
    anchor: [0.5, 0.63],
    animations: {
      run: { spriteTextureName: 'dragon-run' },
      idle: { spriteTextureName: 'dragon-idle' },
      casting: { spriteTextureName: 'dragon-idle' },
      attack: { spriteTextureName: 'dragon-attack' },
      exhaust: { spriteTextureName: 'dragon-exhaust' },
      die: { spriteTextureName: 'dragon-die' },
      fireAttack: { spriteTextureName: 'dragon-fireAttack' },
    },
  },
  lizard: {
    width: 50,
    height: 50,
    anchor: [0.57, 0.57],
    animations: {
      run: { spriteTextureName: 'lizard-run' },
      idle: { spriteTextureName: 'lizard-idle' },
      casting: { spriteTextureName: 'lizard-idle' },
      attack: { spriteTextureName: 'lizard-attack' },
      exhaust: { spriteTextureName: 'lizard-exhaust' },
      die: { spriteTextureName: 'lizard-die' },
    },
  },
  medusa: {
    width: 64,
    height: 64,
    anchor: [0.5, 0.7],
    animations: {
      run: { spriteTextureName: 'medusa-run' },
      idle: { spriteTextureName: 'medusa-idle' },
      casting: { spriteTextureName: 'medusa-idle' },
      attack: { spriteTextureName: 'medusa-attack' },
      exhaust: { spriteTextureName: 'medusa-exhaust' },
      die: { spriteTextureName: 'medusa-die' },
      stone: { spriteTextureName: 'medusa-stone' },
    },
  },
  'small-dragon': {
    width: 40,
    height: 40,
    anchor: [0.6, 0.5],
    animations: {
      run: { spriteTextureName: 'small-dragon-run' },
      idle: { spriteTextureName: 'small-dragon-idle' },
      casting: { spriteTextureName: 'small-dragon-idle' },
      attack: { spriteTextureName: 'small-dragon-attack' },
      exhaust: { spriteTextureName: 'small-dragon-exhaust' },
      die: { spriteTextureName: 'small-dragon-die' },
      fireAttack: { spriteTextureName: 'small-dragon-fireAttack' },
    },
  },
  jinn: {
    width: 64,
    height: 64,
    anchor: [0.65, 0.8],
    animations: {
      run: { spriteTextureName: 'jinn-run' },
      idle: { spriteTextureName: 'jinn-idle' },
      casting: { spriteTextureName: 'jinn-idle' },
      attack: { spriteTextureName: 'jinn-attack' },
      exhaust: { spriteTextureName: 'jinn-exhaust' },
      die: { spriteTextureName: 'jinn-die' },
      magicAttack: { spriteTextureName: 'jinn-magicAttack' },
    },
  },
  knight: {
    width: 40,
    height: 40,
    anchor: [0.5, 0.62],
    animations: {
      run: { spriteTextureName: 'knight-run' },
      idle: { spriteTextureName: 'knight-idle' },
      casting: { spriteTextureName: 'knight-idle' },
      attack: { spriteTextureName: 'knight-attack' },
      exhaust: { spriteTextureName: 'knight-idle' },
      die: { spriteTextureName: 'knight-die' },
      jump: { spriteTextureName: 'knight-jump' },
    },
  },
  'dino-rex': {
    width: 40,
    height: 40,
    anchor: [0.5, 0.85],
    animations: {
      // 384x128 (3:1) frames need a matching display size; idle is 128x128.
      run: { spriteTextureName: 'dino-rex-run', width: 120, height: 40 },
      idle: { spriteTextureName: 'dino-rex-idle' },
      casting: { spriteTextureName: 'dino-rex-idle' },
      attack: { spriteTextureName: 'dino-rex-attack', width: 120, height: 40 },
      exhaust: {
        spriteTextureName: 'dino-rex-exhaust',
        width: 120,
        height: 40,
      },
      die: { spriteTextureName: 'dino-rex-idle' },
      abilityBlack: {
        spriteTextureName: 'dino-rex-abilityBlack',
        width: 120,
        height: 40,
      },
      abilityRed: {
        spriteTextureName: 'dino-rex-abilityRed',
        width: 120,
        height: 40,
      },
      abilityYellow: {
        spriteTextureName: 'dino-rex-abilityYellow',
        width: 120,
        height: 40,
      },
      attackB1Start: {
        spriteTextureName: 'dino-rex-attackB1Start',
        width: 120,
        height: 40,
      },
      attackB2Loop: {
        spriteTextureName: 'dino-rex-attackB2Loop',
        width: 120,
        height: 40,
      },
      attackB3End: {
        spriteTextureName: 'dino-rex-attackB3End',
        width: 120,
        height: 40,
      },
      stomp: { spriteTextureName: 'dino-rex-stomp', width: 120, height: 40 },
    },
  },
  cell: {
    width: 40,
    height: 40,
    anchor: [0.5, 0.5],
    animations: {
      run: { spriteTextureName: 'cell-run' },
      idle: { spriteTextureName: 'cell-idle' },
      casting: { spriteTextureName: 'cell-idle' },
      attack: { spriteTextureName: 'cell-idle' },
      exhaust: { spriteTextureName: 'cell-idle' },
      die: { spriteTextureName: 'cell-idle' },
      windIdle: { spriteTextureName: 'cell-windIdle' },
    },
  },
  phoenixling: {
    width: 40,
    height: 40,
    anchor: [0.5, 0.5],
    animations: {
      run: { spriteTextureName: 'phoenixling-run' },
      idle: { spriteTextureName: 'phoenixling-idle' },
      casting: { spriteTextureName: 'phoenixling-idle' },
      attack: { spriteTextureName: 'phoenixling-attack' },
      exhaust: { spriteTextureName: 'phoenixling-exhaust' },
      die: { spriteTextureName: 'phoenixling-die' },
      rebirth: { spriteTextureName: 'phoenixling-rebirth' },
    },
  },
  ducky: {
    width: 40,
    height: 40,
    anchor: [0.5, 0.75],
    animations: {
      run: { spriteTextureName: 'ducky-run' },
      idle: { spriteTextureName: 'ducky-idle' },
      casting: { spriteTextureName: 'ducky-idle' },
      attack: { spriteTextureName: 'ducky-idle' },
      exhaust: { spriteTextureName: 'ducky-idle' },
      die: { spriteTextureName: 'ducky-idle' },
    },
  },
  bat: {
    width: 73,
    height: 40,
    anchor: [0.5, 0.75],
    animations: {
      run: { spriteTextureName: 'bat-idle' },
      idle: { spriteTextureName: 'bat-idle' },
      casting: { spriteTextureName: 'bat-idle' },
      attack: { spriteTextureName: 'bat-attack2' },
      exhaust: { spriteTextureName: 'bat-hurt' },
      die: { spriteTextureName: 'bat-dead' },
      attack2: { spriteTextureName: 'bat-attack2' },
      hurt: { spriteTextureName: 'bat-hurt' },
      dead: { spriteTextureName: 'bat-dead' },
    },
  },
  beaver: {
    width: 80,
    height: 40,
    anchor: [0.5, 0.75],
    animations: {
      run: { spriteTextureName: 'beaver-walk' },
      idle: { spriteTextureName: 'beaver-idle' },
      casting: { spriteTextureName: 'beaver-idle' },
      attack: { spriteTextureName: 'beaver-attack1' },
      exhaust: { spriteTextureName: 'beaver-hit' },
      die: { spriteTextureName: 'beaver-dead' },
      walk: { spriteTextureName: 'beaver-walk' },
      attack1: { spriteTextureName: 'beaver-attack1' },
      attack2: { spriteTextureName: 'beaver-attack2' },
      hit: { spriteTextureName: 'beaver-hit' },
      dead: { spriteTextureName: 'beaver-dead' },
    },
  },
  dragonfly: {
    width: 50,
    height: 40,
    anchor: [0.5, 0.75],
    animations: {
      run: { spriteTextureName: 'dragonfly-idle' },
      idle: { spriteTextureName: 'dragonfly-idle' },
      casting: { spriteTextureName: 'dragonfly-idle' },
      attack: { spriteTextureName: 'dragonfly-attack1' },
      exhaust: { spriteTextureName: 'dragonfly-hitTest' },
      die: { spriteTextureName: 'dragonfly-dead' },
      hitTest: { spriteTextureName: 'dragonfly-hitTest' },
      attack1: { spriteTextureName: 'dragonfly-attack1' },
      attack2: { spriteTextureName: 'dragonfly-attack2' },
      hit: { spriteTextureName: 'dragonfly-hit' },
      dead: { spriteTextureName: 'dragonfly-dead' },
    },
  },
  frog: {
    width: 80,
    height: 40,
    anchor: [0.5, 0.8],
    animations: {
      run: { spriteTextureName: 'frog-idle1' },
      idle: { spriteTextureName: 'frog-idle1' },
      casting: { spriteTextureName: 'frog-idle1' },
      attack: { spriteTextureName: 'frog-attack1' },
      exhaust: { spriteTextureName: 'frog-hit' },
      die: { spriteTextureName: 'frog-dead' },
      idle1: { spriteTextureName: 'frog-idle1' },
      idle2: { spriteTextureName: 'frog-idle2' },
      jump: { spriteTextureName: 'frog-jump' },
      jumpIdle: { spriteTextureName: 'frog-jumpIdle' },
      jumpLanding: { spriteTextureName: 'frog-jumpLanding' },
      attack1: { spriteTextureName: 'frog-attack1' },
      hit: { spriteTextureName: 'frog-hit' },
      dead: { spriteTextureName: 'frog-dead' },
    },
  },
  molerat: {
    width: 40,
    height: 40,
    anchor: [0.5, 0.75],
    animations: {
      run: { spriteTextureName: 'molerat-walk' },
      idle: { spriteTextureName: 'molerat-idle' },
      casting: { spriteTextureName: 'molerat-idle' },
      attack: { spriteTextureName: 'molerat-attack1' },
      exhaust: { spriteTextureName: 'molerat-hit' },
      die: { spriteTextureName: 'molerat-dead' },
      walk: { spriteTextureName: 'molerat-walk' },
      attack1: { spriteTextureName: 'molerat-attack1' },
      rollStart: { spriteTextureName: 'molerat-rollStart' },
      rollIdle: { spriteTextureName: 'molerat-rollIdle' },
      rollStop: { spriteTextureName: 'molerat-rollStop' },
      hit: { spriteTextureName: 'molerat-hit' },
      dead: { spriteTextureName: 'molerat-dead' },
    },
  },
  rhino: {
    width: 80,
    height: 40,
    anchor: [0.5, 0.75],
    animations: {
      run: { spriteTextureName: 'rhino-walk' },
      idle: { spriteTextureName: 'rhino-idle' },
      casting: { spriteTextureName: 'rhino-idle' },
      attack: { spriteTextureName: 'rhino-attack1' },
      exhaust: { spriteTextureName: 'rhino-hit' },
      die: { spriteTextureName: 'rhino-dead' },
      walk: { spriteTextureName: 'rhino-walk' },
      attack1: { spriteTextureName: 'rhino-attack1' },
      attack2: { spriteTextureName: 'rhino-attack2' },
      hit: { spriteTextureName: 'rhino-hit' },
      dead: { spriteTextureName: 'rhino-dead' },
    },
  },
  shoebill: {
    width: 64,
    height: 64,
    anchor: [0.5, 0.75],
    animations: {
      run: { spriteTextureName: 'shoebill-walk' },
      idle: { spriteTextureName: 'shoebill-idle' },
      casting: { spriteTextureName: 'shoebill-idle' },
      attack: { spriteTextureName: 'shoebill-attack' },
      exhaust: { spriteTextureName: 'shoebill-hit' },
      die: { spriteTextureName: 'shoebill-dead' },
      walk: { spriteTextureName: 'shoebill-walk' },
      eggLays: { spriteTextureName: 'shoebill-eggLays' },
      hit: { spriteTextureName: 'shoebill-hit' },
      dead: { spriteTextureName: 'shoebill-dead' },
    },
  },
  worm: {
    width: 40,
    height: 40,
    anchor: [0.5, 0.75],
    animations: {
      run: { spriteTextureName: 'worm-walk' },
      idle: { spriteTextureName: 'worm-idle' },
      casting: { spriteTextureName: 'worm-idle' },
      attack: { spriteTextureName: 'worm-attack1' },
      exhaust: { spriteTextureName: 'worm-hit' },
      die: { spriteTextureName: 'worm-dead' },
      walk: { spriteTextureName: 'worm-walk' },
      attack1: { spriteTextureName: 'worm-attack1' },
      hide: { spriteTextureName: 'worm-hide' },
      appear: { spriteTextureName: 'worm-appear' },
      hit: { spriteTextureName: 'worm-hit' },
      dead: { spriteTextureName: 'worm-dead' },
    },
  },
  'shoebill-chick': {
    width: 20,
    height: 20,
    anchor: [0.5, 0.75],
    animations: {
      run: { spriteTextureName: 'shoebill-chick-walk' },
      idle: { spriteTextureName: 'shoebill-chick-idle' },
      casting: { spriteTextureName: 'shoebill-chick-idle' },
      attack: { spriteTextureName: 'shoebill-chick-walk' },
      exhaust: { spriteTextureName: 'shoebill-chick-idle' },
      die: { spriteTextureName: 'shoebill-chick-kamikaze' },
      eggIdle: { spriteTextureName: 'shoebill-chick-eggIdle' },
      outOfAnEgg: { spriteTextureName: 'shoebill-chick-outOfAnEgg' },
      walk: { spriteTextureName: 'shoebill-chick-walk' },
      kamikaze: { spriteTextureName: 'shoebill-chick-kamikaze' },
    },
  },
  'type2-00': {
    width: 40,
    height: 40,
    anchor: [0.5, 0.65],
    animations: {
      run: { spriteTextureName: 'type2-00-run' },
      idle: { spriteTextureName: 'type2-00-idle' },
      casting: { spriteTextureName: 'type2-00-idle' },
      attack: { spriteTextureName: 'type2-00-idle' },
      exhaust: { spriteTextureName: 'type2-00-idle' },
      die: { spriteTextureName: 'type2-00-idle' },
      action2: { spriteTextureName: 'type2-00-action2' },
      action3: { spriteTextureName: 'type2-00-action3' },
      action4: { spriteTextureName: 'type2-00-action4' },
      action5: { spriteTextureName: 'type2-00-action5' },
      action6: { spriteTextureName: 'type2-00-action6' },
      action7: { spriteTextureName: 'type2-00-action7' },
      action8: { spriteTextureName: 'type2-00-action8' },
      action9: { spriteTextureName: 'type2-00-action9' },
      action10: { spriteTextureName: 'type2-00-action10' },
      action11: { spriteTextureName: 'type2-00-action11' },
      action12: { spriteTextureName: 'type2-00-action12' },
      action13: { spriteTextureName: 'type2-00-action13' },
      action14: { spriteTextureName: 'type2-00-action14' },
      action15: { spriteTextureName: 'type2-00-action15' },
      action16: { spriteTextureName: 'type2-00-action16' },
    },
  },
  'type2-01': {
    width: 40,
    height: 40,
    anchor: [0.5, 0.65],
    animations: {
      run: { spriteTextureName: 'type2-01-run' },
      idle: { spriteTextureName: 'type2-01-idle' },
      casting: { spriteTextureName: 'type2-01-idle' },
      attack: { spriteTextureName: 'type2-01-idle' },
      exhaust: { spriteTextureName: 'type2-01-idle' },
      die: { spriteTextureName: 'type2-01-idle' },
      action2: { spriteTextureName: 'type2-01-action2' },
      action3: { spriteTextureName: 'type2-01-action3' },
      action4: { spriteTextureName: 'type2-01-action4' },
      action5: { spriteTextureName: 'type2-01-action5' },
      action6: { spriteTextureName: 'type2-01-action6' },
      action7: { spriteTextureName: 'type2-01-action7' },
      action8: { spriteTextureName: 'type2-01-action8' },
      action9: { spriteTextureName: 'type2-01-action9' },
      action10: { spriteTextureName: 'type2-01-action10' },
      action11: { spriteTextureName: 'type2-01-action11' },
      action12: { spriteTextureName: 'type2-01-action12' },
      action13: { spriteTextureName: 'type2-01-action13' },
      action14: { spriteTextureName: 'type2-01-action14' },
      action15: { spriteTextureName: 'type2-01-action15' },
      action16: { spriteTextureName: 'type2-01-action16' },
    },
  },
  'type2-02': {
    width: 40,
    height: 40,
    anchor: [0.5, 0.65],
    animations: {
      run: { spriteTextureName: 'type2-02-run' },
      idle: { spriteTextureName: 'type2-02-idle' },
      casting: { spriteTextureName: 'type2-02-idle' },
      attack: { spriteTextureName: 'type2-02-idle' },
      exhaust: { spriteTextureName: 'type2-02-idle' },
      die: { spriteTextureName: 'type2-02-idle' },
      action2: { spriteTextureName: 'type2-02-action2' },
      action3: { spriteTextureName: 'type2-02-action3' },
      action4: { spriteTextureName: 'type2-02-action4' },
      action5: { spriteTextureName: 'type2-02-action5' },
      action6: { spriteTextureName: 'type2-02-action6' },
      action7: { spriteTextureName: 'type2-02-action7' },
      action8: { spriteTextureName: 'type2-02-action8' },
      action9: { spriteTextureName: 'type2-02-action9' },
      action10: { spriteTextureName: 'type2-02-action10' },
      action11: { spriteTextureName: 'type2-02-action11' },
      action12: { spriteTextureName: 'type2-02-action12' },
      action13: { spriteTextureName: 'type2-02-action13' },
      action14: { spriteTextureName: 'type2-02-action14' },
      action15: { spriteTextureName: 'type2-02-action15' },
      action16: { spriteTextureName: 'type2-02-action16' },
    },
  },
  'type2-03': {
    width: 40,
    height: 40,
    anchor: [0.5, 0.65],
    animations: {
      run: { spriteTextureName: 'type2-03-run' },
      idle: { spriteTextureName: 'type2-03-idle' },
      casting: { spriteTextureName: 'type2-03-idle' },
      attack: { spriteTextureName: 'type2-03-idle' },
      exhaust: { spriteTextureName: 'type2-03-idle' },
      die: { spriteTextureName: 'type2-03-idle' },
      action2: { spriteTextureName: 'type2-03-action2' },
      action3: { spriteTextureName: 'type2-03-action3' },
      action4: { spriteTextureName: 'type2-03-action4' },
      action5: { spriteTextureName: 'type2-03-action5' },
      action6: { spriteTextureName: 'type2-03-action6' },
      action7: { spriteTextureName: 'type2-03-action7' },
      action8: { spriteTextureName: 'type2-03-action8' },
      action9: { spriteTextureName: 'type2-03-action9' },
      action10: { spriteTextureName: 'type2-03-action10' },
      action11: { spriteTextureName: 'type2-03-action11' },
      action12: { spriteTextureName: 'type2-03-action12' },
      action13: { spriteTextureName: 'type2-03-action13' },
      action14: { spriteTextureName: 'type2-03-action14' },
      action15: { spriteTextureName: 'type2-03-action15' },
      action16: { spriteTextureName: 'type2-03-action16' },
    },
  },
  'type2-04': {
    width: 40,
    height: 40,
    anchor: [0.5, 0.65],
    animations: {
      run: { spriteTextureName: 'type2-04-run' },
      idle: { spriteTextureName: 'type2-04-idle' },
      casting: { spriteTextureName: 'type2-04-idle' },
      attack: { spriteTextureName: 'type2-04-idle' },
      exhaust: { spriteTextureName: 'type2-04-idle' },
      die: { spriteTextureName: 'type2-04-idle' },
      action2: { spriteTextureName: 'type2-04-action2' },
      action3: { spriteTextureName: 'type2-04-action3' },
      action4: { spriteTextureName: 'type2-04-action4' },
      action5: { spriteTextureName: 'type2-04-action5' },
      action6: { spriteTextureName: 'type2-04-action6' },
      action7: { spriteTextureName: 'type2-04-action7' },
      action8: { spriteTextureName: 'type2-04-action8' },
      action9: { spriteTextureName: 'type2-04-action9' },
      action10: { spriteTextureName: 'type2-04-action10' },
      action11: { spriteTextureName: 'type2-04-action11' },
      action12: { spriteTextureName: 'type2-04-action12' },
      action13: { spriteTextureName: 'type2-04-action13' },
      action14: { spriteTextureName: 'type2-04-action14' },
      action15: { spriteTextureName: 'type2-04-action15' },
      action16: { spriteTextureName: 'type2-04-action16' },
    },
  },
  'type2-05': {
    width: 40,
    height: 40,
    anchor: [0.5, 0.65],
    animations: {
      run: { spriteTextureName: 'type2-05-run' },
      idle: { spriteTextureName: 'type2-05-idle' },
      casting: { spriteTextureName: 'type2-05-idle' },
      attack: { spriteTextureName: 'type2-05-idle' },
      exhaust: { spriteTextureName: 'type2-05-idle' },
      die: { spriteTextureName: 'type2-05-idle' },
      action2: { spriteTextureName: 'type2-05-action2' },
      action3: { spriteTextureName: 'type2-05-action3' },
      action4: { spriteTextureName: 'type2-05-action4' },
      action5: { spriteTextureName: 'type2-05-action5' },
      action6: { spriteTextureName: 'type2-05-action6' },
      action7: { spriteTextureName: 'type2-05-action7' },
      action8: { spriteTextureName: 'type2-05-action8' },
      action9: { spriteTextureName: 'type2-05-action9' },
      action10: { spriteTextureName: 'type2-05-action10' },
      action11: { spriteTextureName: 'type2-05-action11' },
      action12: { spriteTextureName: 'type2-05-action12' },
      action13: { spriteTextureName: 'type2-05-action13' },
      action14: { spriteTextureName: 'type2-05-action14' },
      action15: { spriteTextureName: 'type2-05-action15' },
      action16: { spriteTextureName: 'type2-05-action16' },
    },
  },
  'type2-06': {
    width: 40,
    height: 40,
    anchor: [0.5, 0.65],
    animations: {
      run: { spriteTextureName: 'type2-06-run' },
      idle: { spriteTextureName: 'type2-06-idle' },
      casting: { spriteTextureName: 'type2-06-idle' },
      attack: { spriteTextureName: 'type2-06-idle' },
      exhaust: { spriteTextureName: 'type2-06-idle' },
      die: { spriteTextureName: 'type2-06-idle' },
      action2: { spriteTextureName: 'type2-06-action2' },
      action3: { spriteTextureName: 'type2-06-action3' },
      action4: { spriteTextureName: 'type2-06-action4' },
      action5: { spriteTextureName: 'type2-06-action5' },
      action6: { spriteTextureName: 'type2-06-action6' },
      action7: { spriteTextureName: 'type2-06-action7' },
      action8: { spriteTextureName: 'type2-06-action8' },
      action9: { spriteTextureName: 'type2-06-action9' },
      action10: { spriteTextureName: 'type2-06-action10' },
      action11: { spriteTextureName: 'type2-06-action11' },
      action12: { spriteTextureName: 'type2-06-action12' },
      action13: { spriteTextureName: 'type2-06-action13' },
      action14: { spriteTextureName: 'type2-06-action14' },
      action15: { spriteTextureName: 'type2-06-action15' },
      action16: { spriteTextureName: 'type2-06-action16' },
    },
  },
  'type2-07': {
    width: 40,
    height: 40,
    anchor: [0.5, 0.65],
    animations: {
      run: { spriteTextureName: 'type2-07-run' },
      idle: { spriteTextureName: 'type2-07-idle' },
      casting: { spriteTextureName: 'type2-07-idle' },
      attack: { spriteTextureName: 'type2-07-idle' },
      exhaust: { spriteTextureName: 'type2-07-idle' },
      die: { spriteTextureName: 'type2-07-idle' },
      action2: { spriteTextureName: 'type2-07-action2' },
      action3: { spriteTextureName: 'type2-07-action3' },
      action4: { spriteTextureName: 'type2-07-action4' },
      action5: { spriteTextureName: 'type2-07-action5' },
      action6: { spriteTextureName: 'type2-07-action6' },
      action7: { spriteTextureName: 'type2-07-action7' },
      action8: { spriteTextureName: 'type2-07-action8' },
      action9: { spriteTextureName: 'type2-07-action9' },
      action10: { spriteTextureName: 'type2-07-action10' },
      action11: { spriteTextureName: 'type2-07-action11' },
      action12: { spriteTextureName: 'type2-07-action12' },
      action13: { spriteTextureName: 'type2-07-action13' },
      action14: { spriteTextureName: 'type2-07-action14' },
      action15: { spriteTextureName: 'type2-07-action15' },
      action16: { spriteTextureName: 'type2-07-action16' },
    },
  },
  'type2-08': {
    width: 40,
    height: 40,
    anchor: [0.5, 0.65],
    animations: {
      run: { spriteTextureName: 'type2-08-run' },
      idle: { spriteTextureName: 'type2-08-idle' },
      casting: { spriteTextureName: 'type2-08-idle' },
      attack: { spriteTextureName: 'type2-08-idle' },
      exhaust: { spriteTextureName: 'type2-08-idle' },
      die: { spriteTextureName: 'type2-08-idle' },
      action2: { spriteTextureName: 'type2-08-action2' },
      action3: { spriteTextureName: 'type2-08-action3' },
      action4: { spriteTextureName: 'type2-08-action4' },
      action5: { spriteTextureName: 'type2-08-action5' },
      action6: { spriteTextureName: 'type2-08-action6' },
      action7: { spriteTextureName: 'type2-08-action7' },
      action8: { spriteTextureName: 'type2-08-action8' },
      action9: { spriteTextureName: 'type2-08-action9' },
      action10: { spriteTextureName: 'type2-08-action10' },
      action11: { spriteTextureName: 'type2-08-action11' },
      action12: { spriteTextureName: 'type2-08-action12' },
      action13: { spriteTextureName: 'type2-08-action13' },
      action14: { spriteTextureName: 'type2-08-action14' },
      action15: { spriteTextureName: 'type2-08-action15' },
      action16: { spriteTextureName: 'type2-08-action16' },
    },
  },
  'type2-09': {
    width: 40,
    height: 40,
    anchor: [0.5, 0.65],
    animations: {
      run: { spriteTextureName: 'type2-09-run' },
      idle: { spriteTextureName: 'type2-09-idle' },
      casting: { spriteTextureName: 'type2-09-idle' },
      attack: { spriteTextureName: 'type2-09-idle' },
      exhaust: { spriteTextureName: 'type2-09-idle' },
      die: { spriteTextureName: 'type2-09-idle' },
      action2: { spriteTextureName: 'type2-09-action2' },
      action3: { spriteTextureName: 'type2-09-action3' },
      action4: { spriteTextureName: 'type2-09-action4' },
      action5: { spriteTextureName: 'type2-09-action5' },
      action6: { spriteTextureName: 'type2-09-action6' },
      action7: { spriteTextureName: 'type2-09-action7' },
      action8: { spriteTextureName: 'type2-09-action8' },
      action9: { spriteTextureName: 'type2-09-action9' },
      action10: { spriteTextureName: 'type2-09-action10' },
      action11: { spriteTextureName: 'type2-09-action11' },
      action12: { spriteTextureName: 'type2-09-action12' },
      action13: { spriteTextureName: 'type2-09-action13' },
      action14: { spriteTextureName: 'type2-09-action14' },
      action15: { spriteTextureName: 'type2-09-action15' },
      action16: { spriteTextureName: 'type2-09-action16' },
    },
  },
  'type2-10': {
    width: 40,
    height: 40,
    anchor: [0.5, 0.65],
    animations: {
      run: { spriteTextureName: 'type2-10-run' },
      idle: { spriteTextureName: 'type2-10-idle' },
      casting: { spriteTextureName: 'type2-10-idle' },
      attack: { spriteTextureName: 'type2-10-idle' },
      exhaust: { spriteTextureName: 'type2-10-idle' },
      die: { spriteTextureName: 'type2-10-idle' },
      action2: { spriteTextureName: 'type2-10-action2' },
      action3: { spriteTextureName: 'type2-10-action3' },
      action4: { spriteTextureName: 'type2-10-action4' },
      action5: { spriteTextureName: 'type2-10-action5' },
      action6: { spriteTextureName: 'type2-10-action6' },
      action7: { spriteTextureName: 'type2-10-action7' },
      action8: { spriteTextureName: 'type2-10-action8' },
      action9: { spriteTextureName: 'type2-10-action9' },
      action10: { spriteTextureName: 'type2-10-action10' },
      action11: { spriteTextureName: 'type2-10-action11' },
      action12: { spriteTextureName: 'type2-10-action12' },
      action13: { spriteTextureName: 'type2-10-action13' },
      action14: { spriteTextureName: 'type2-10-action14' },
      action15: { spriteTextureName: 'type2-10-action15' },
      action16: { spriteTextureName: 'type2-10-action16' },
    },
  },
  astronaut: {
    width: 40,
    height: 40,
    anchor: [0.5, 0.75],
    animations: {
      run: { spriteTextureName: 'astronaut-walk' },
      idle: { spriteTextureName: 'astronaut-walk' },
      casting: { spriteTextureName: 'astronaut-walk' },
      attack: { spriteTextureName: 'astronaut-walk' },
      exhaust: { spriteTextureName: 'astronaut-walk' },
      die: { spriteTextureName: 'astronaut-walk' },
    },
  },
};
